export enum CompanySuggestionEnum {
	ACTIVE = 'Действующая',
	REORGANIZATION = 'Реорганизация',
	LIQUIDATION = 'Ликвидируется',
	BANKRUPT = 'Банкротство',
	LIQUIDATED = 'Ликвидирована',
}